export class Usuario{
    public Token: string;

    public UsuarioID: number;
    public RegistroANS: number;
    public TipoUsuario: number;
    public Nome: string;
    public Email: string;
    public Senha: string;
    
    public Situacao: number;
    public DataSituacao: Date;
    public MotivoSituacoa: string;
    
    public Ouvidoria: number;
    public SAC: number;    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/config/usuario.ts
 **/